import { render, staticRenderFns } from "./StylesTab.vue?vue&type=template&id=3385b7ca"
import script from "./StylesTab.vue?vue&type=script&lang=js"
export * from "./StylesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports